import {
    Avatar,
    Button,
    Grid,
    List,
    ListItem,
    ListItemAvatar,
    ListItemText,
} from '@mui/material';
import { useSnackbar } from 'notistack';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useCreateListDataMutation } from '../../api/apiSlice';
import ConfirmSheet from '../../components/fragments/ConfirmSheet';
import ExternalScreen from '../../components/fragments/ExternalScreen';
import ListEmpty from '../../components/fragments/ListEmpty';
import { rtGetListData } from '../../store/slices/listSlice';
import errorSnackbar from '../../utils/errorSnackbar';

export default function MyPastors() {
    const [modalOpen, setModalOpen] = useState(false);
    const [ministerUsername, setMinisterUsername] = useState(null);

    const { enqueueSnackbar } = useSnackbar();
    const dispatch = useDispatch();
    const state = useSelector((st) => st);
    const { pastors, busy } = state.list2;

    const [toggleFollow, { isLoading }] = useCreateListDataMutation();

    useEffect(() => {
        dispatch(rtGetListData('pastors', 'pastors'));
    }, [dispatch]);

    return (
        <ExternalScreen loading={busy['pastors']} title="My Pastors">
            <Grid item xs={12}>
                {!!(pastors?.length < 1) && <ListEmpty />}
                <List>
                    {pastors?.map(
                        ({
                            id,
                            firstName,
                            surname,
                            links: { avatar },
                            estate,
                            username,
                        }) => (
                            <ListItem sx={{ p: 0 }} key={id}>
                                <ListItemAvatar>
                                    <Avatar src={avatar}>
                                        {firstName?.slice(0, 1)}
                                    </Avatar>
                                </ListItemAvatar>
                                <ListItemText
                                    secondary={estate}
                                    primary={`${firstName} ${surname}`}
                                />
                                <Button
                                    onClick={() => {
                                        setModalOpen(true);
                                        setMinisterUsername(username);
                                    }}
                                    size="small"
                                    variant="outlined"
                                >
                                    Unfollow
                                </Button>
                            </ListItem>
                        )
                    )}
                </List>
                <ConfirmSheet
                    open={modalOpen}
                    isLoading={isLoading}
                    onCancel={() => setModalOpen(false)}
                    onConfirm={async () => {
                        const { data, error } = await toggleFollow({
                            list: `/pastor/${ministerUsername}/toggle_follow`,
                            body: {},
                        });

                        errorSnackbar(error, enqueueSnackbar);

                        if (data) {
                            enqueueSnackbar(`${data?.message}`);
                            dispatch(rtGetListData('pastors', 'pastors'));
                            setModalOpen(false);
                        }
                    }}
                />
            </Grid>
        </ExternalScreen>
    );
}
